export const SIGN_IN_URL = "https://claude.ai/artifact/7vMAQbBp3JNxxJSjkeg4zq";
export const CONTACT = { email: "tlvporthotel@gmail.com", phone: "+972 9-9596000", tel: "+97299596000", whatsapp: "97299596000" };

const en = {
  nav: { property: "The hotel", gallery: "Gallery", plans: "Plans", company: "Company", club: "Owners' club", contact: "Contact", signIn: "Members' sign-in", cta: "Request a viewing", menu: "Menu", close: "Close" },
  hero: {
    eyebrow: "Property no. 1 · Tel Aviv Port",
    lines: ["Where the port", "meets the sea"],
    intro: "A new Hagag Group building on the Tel Aviv waterfront, a few steps from the port promenade and the beach. Forty-four furnished hotel units behind a carved white screen facade that filters the Mediterranean light, with a turquoise indoor pool, a fitness room and a quiet lobby of pale stone.",
    explore: "Explore the hotel",
    scroll: "Scroll",
    caption: "The facade",
  },
  marquee: ["Tel Aviv Port", "Registered freehold", "Forty-four furnished units", "Leased to Jacob Hotels", "Thirty nights a year", "Opening 2027"],
  stats: {
    eyebrow: "Property no. 1",
    title: "Forty-four units, one horizon",
    items: [
      { v: "44", k: "Hotel units, delivered furnished" },
      { v: "Tabo", k: "Registered freehold title" },
      { v: "Sea", k: "Facing units with terraces" },
      { v: "Pool · Gym", k: "Indoor pool, fitness room, lobby lounge" },
      { v: "Operator", k: "Leased to and operated by Jacob Hotels" },
      { v: "2027", k: "Planned opening" },
    ],
  },
  gallery: {
    eyebrow: "Inside the building",
    title: "White walls, turquoise water, Mediterranean light",
    view: "View",
    captions: ["The facade", "Sea-facing unit", "Indoor pool", "Fitness", "Lobby", "Lounge", "Unit interiors", "Lobby lighting"],
  },
  plans: {
    eyebrow: "Plans",
    title: "Two floors facing the Mediterranean",
    body: "The hotel sits on the first and second floors, above its own lobby with a dedicated lift, security and service rooms. Twenty-two units per floor, from 19 to 32 m², each with a balcony open to the sea breeze; the indoor pool and gym share the second floor.",
    tabs: [
      { label: "Lobby floor", meta: "Ground", desc: "Hotel lobby and hotel lift, separate from the residents' lobby; synagogue; three commercial units on the street." },
      { label: "First floor", meta: "Units 1–22", desc: "Sea-side units with 11–28 m² balconies; corner units of 26–32 m²." },
      { label: "Second floor", meta: "Units 23–44", desc: "Indoor pool with its terrace, gym technical area, security room; balconies of 11–13 m²." },
    ],
    note: "Plans from the developer's sales book, reproduced at screen resolution; areas as marked on the plans. Definitive plans and the registered areas follow the title documents.",
    enlarge: "Enlarge plan",
  },
  film: {
    eyebrow: "Film",
    title: "The port, from the water",
    body: "A short film on Port TLV: white walls, turquoise water and the evening light over the port, a few steps from the promenade and the beach.",
    status: "Port TLV · Hotel & Residence",
    play: "Play with sound",
  },
  company: {
    eyebrow: "The company",
    title: "Own the walls by the sea. Let the best run the rooms.",
    body: "OGEN is a holding company, not a hotel operator. It owns hospitality real estate in Israel's best locations, along the Mediterranean and beyond, and leases each hotel, long term, to an established brand that runs it under its own name.",
    pillars: [
      { k: "Own", title: "Prime addresses, freehold", body: "Each property is held in registered title by the company. Investors hold shares in the company, not in a single room, so every owner has a stake in every hotel." },
      { k: "Operate", title: "Leased to Jacob Hotels", body: "A long-term lease to a chain of ten hotels: fixed income for the company, professional management, no day-to-day involvement for shareholders. The hotel carries the operator's name." },
      { k: "Grow", title: "From one hotel to a collection", body: "Capital retained after the first acquisition, together with bank finance, is directed at the next hotel. The aim is a chain of boutique properties across Israel, from the coast to the desert." },
    ],
  },
  club: {
    eyebrow: "Owners' club",
    title: "Your own corner of the Mediterranean",
    body: "Shareholders are members of the house. Ownership comes with the right to stay by the sea, and with privileges across the ten Jacob Hotels in Israel.",
    perks: [
      { title: "Thirty nights a year, at the port", body: "Taken in one stay or several, in any season. Members who don't use their nights may offer them to others or opt for a fixed allowance." },
      { title: "A member card for the whole chain", body: "The Jacob Hotels club card: privileged rates at the chain's hotels from Neve Ativ in the Golan to Eilat, including Shenkin TLV, Harmony Jerusalem and Mitzpe Ramon." },
      { title: "A seat in a growing company", body: "Shareholders own every property the company acquires, not only the first." },
    ],
    signIn: "Members' sign-in",
    note: "Invited shareholders sign in with the email address their invitation was sent to. Documents, figures and votes are there.",
    member: "Member",
    ownerNo: "Owner no. 01 of 44",
  },
  partners: {
    eyebrow: "Partners",
    title: "The hands behind the white facade",
    list: [
      { name: "Hagag Group", role: "Developer & builder", body: "Developer and builder of the Tel Aviv Port property. One of Israel's leading residential and hospitality developers." },
      { name: "Jacob Hotels", role: "Operator", body: "Operator of the Port Hotel under a long-term lease, and of ten hotels across Israel, from the Golan to Eilat." },
      { name: "OGEN Hospitality", role: "Sponsor & manager", body: "Sponsor and manager of the company: structuring, acquisition, legal, and the owners' club." },
    ],
  },
  contact: {
    eyebrow: "Contact",
    title: "Come and see the sea from here",
    body: "Come down to the port for a private viewing of the show unit and the pool floor, by appointment. Conversations in English, French or Hebrew.",
    emailL: "Email", phoneL: "Telephone", officeL: "Office", office: "Mefi St. 5, Netanya, Israel",
    form: { firstName: "First name", lastName: "Last name", email: "Email", phone: "Telephone", prefLang: "Preferred language", message: "Message", submit: "Request a viewing", sending: "Sending…" },
    successTitle: "Request received",
    success: "Thank you. We will be in touch to arrange your visit.",
    error: "Something went wrong. Please try again or write to us directly.",
    required: "Please fill in your name and a valid email.",
  },
  footer: { tagline: "Hospitality on the Mediterranean, held for the long term.", rights: "All rights reserved", backTop: "Back to top" },
  whatsapp: { label: "Message us on WhatsApp", message: "Hello, I'd like to arrange a viewing at the Tel Aviv Port hotel." },
};

const fr = {
  nav: { property: "L'hôtel", gallery: "Galerie", plans: "Plans", company: "Société", club: "Club", contact: "Contact", signIn: "Espace membres", cta: "Demander une visite", menu: "Menu", close: "Fermer" },
  hero: {
    eyebrow: "Propriété n° 1 · Port de Tel Aviv",
    lines: ["Là où le port", "rencontre la mer"],
    intro: "Un nouvel immeuble du groupe Hagag sur le front de mer de Tel Aviv, à quelques pas de la promenade du port et de la plage. Quarante-quatre unités hôtelières meublées derrière une façade de résille blanche sculptée qui filtre la lumière méditerranéenne, avec une piscine intérieure turquoise, une salle de fitness et un lobby paisible de pierre claire.",
    explore: "Découvrir l'hôtel",
    scroll: "Défiler",
    caption: "La façade",
  },
  marquee: ["Port de Tel Aviv", "Pleine propriété enregistrée", "Quarante-quatre unités meublées", "Loué à Jacob Hotels", "Trente nuits par an", "Ouverture 2027"],
  stats: {
    eyebrow: "Propriété n° 1",
    title: "Quarante-quatre unités, un seul horizon",
    items: [
      { v: "44", k: "Unités hôtelières, livrées meublées" },
      { v: "Tabo", k: "Titre de pleine propriété enregistré" },
      { v: "Mer", k: "Unités face à la mer avec terrasses" },
      { v: "Piscine · Gym", k: "Piscine intérieure, salle de fitness, lounge" },
      { v: "Exploitant", k: "Loué à et exploité par Jacob Hotels" },
      { v: "2027", k: "Ouverture prévue" },
    ],
  },
  gallery: {
    eyebrow: "Le bâtiment",
    title: "Murs blancs, eau turquoise, lumière méditerranéenne",
    view: "Voir",
    captions: ["La façade", "Unité face à la mer", "Piscine intérieure", "Fitness", "Lobby", "Lounge", "Intérieurs", "Luminaires du lobby"],
  },
  plans: {
    eyebrow: "Plans",
    title: "Deux étages face à la Méditerranée",
    body: "L'hôtel occupe le premier et le deuxième étage, au-dessus de son propre lobby avec ascenseur dédié, sécurité et locaux de service. Vingt-deux unités par étage, de 19 à 32 m², chacune avec un balcon ouvert à la brise marine ; la piscine intérieure et la salle de sport se partagent le deuxième étage.",
    tabs: [
      { label: "Rez-de-chaussée", meta: "Lobby", desc: "Lobby et ascenseur de l'hôtel, séparés du lobby des résidents ; synagogue ; trois locaux commerciaux sur rue." },
      { label: "Premier étage", meta: "Unités 1–22", desc: "Unités côté mer avec balcons de 11 à 28 m² ; unités d'angle de 26 à 32 m²." },
      { label: "Deuxième étage", meta: "Unités 23–44", desc: "Piscine intérieure et sa terrasse, espace technique de la salle de sport, local de sécurité ; balcons de 11 à 13 m²." },
    ],
    note: "Plans issus du dossier de vente du promoteur, reproduits en résolution écran ; surfaces telles qu'indiquées sur les plans. Les plans définitifs et les surfaces enregistrées suivent les titres de propriété.",
    enlarge: "Agrandir le plan",
  },
  film: {
    eyebrow: "Film",
    title: "Le port, vu de la mer",
    body: "Un court-métrage sur Port TLV : murs blancs, eau turquoise et lumière du soir sur le port, à quelques pas de la promenade et de la plage.",
    status: "Port TLV · Hôtel & Résidence",
    play: "Lire avec le son",
  },
  company: {
    eyebrow: "La société",
    title: "Posséder les murs face à la mer. Confier les chambres aux meilleurs.",
    body: "OGEN est une société holding, pas un exploitant hôtelier. Elle détient de l'immobilier hôtelier dans les meilleurs emplacements d'Israël, au bord de la Méditerranée et au-delà, et loue chaque hôtel, à long terme, à une enseigne établie qui l'exploite sous son propre nom.",
    pillars: [
      { k: "Posséder", title: "Des adresses de premier ordre, en pleine propriété", body: "Chaque bien est détenu en titre enregistré par la société. Les investisseurs détiennent des actions de la société, et non une chambre isolée : chaque propriétaire a une part dans chaque hôtel." },
      { k: "Exploiter", title: "Loué à Jacob Hotels", body: "Un bail de longue durée avec une chaîne de dix hôtels : un revenu fixe pour la société, une gestion professionnelle, aucune implication quotidienne pour les actionnaires. L'hôtel porte le nom de l'exploitant." },
      { k: "Grandir", title: "D'un hôtel à une collection", body: "Le capital conservé après la première acquisition, complété par un financement bancaire, est orienté vers l'hôtel suivant. L'objectif : une chaîne d'hôtels-boutiques à travers Israël, de la côte au désert." },
    ],
  },
  club: {
    eyebrow: "Club des propriétaires",
    title: "Votre coin de Méditerranée",
    body: "Les actionnaires sont membres de la maison. La propriété s'accompagne du droit de séjourner au bord de la mer, et de privilèges dans les dix hôtels Jacob en Israël.",
    perks: [
      { title: "Trente nuits par an, au port", body: "En un seul séjour ou en plusieurs, en toute saison. Les membres qui n'utilisent pas leurs nuits peuvent les offrir à d'autres ou opter pour une allocation fixe." },
      { title: "Une carte de membre pour toute la chaîne", body: "La carte club Jacob Hotels : des tarifs privilégiés dans les hôtels de la chaîne, de Neve Ativ dans le Golan à Eilat, dont Shenkin TLV, Harmony Jérusalem et Mitzpe Ramon." },
      { title: "Un siège dans une société en croissance", body: "Les actionnaires possèdent chaque bien acquis par la société, pas seulement le premier." },
    ],
    signIn: "Espace membres",
    note: "Les actionnaires invités se connectent avec l'adresse e-mail à laquelle leur invitation a été envoyée. Documents, chiffres et votes s'y trouvent.",
    member: "Membre",
    ownerNo: "Propriétaire n° 01 sur 44",
  },
  partners: {
    eyebrow: "Partenaires",
    title: "Les mains derrière la façade blanche",
    list: [
      { name: "Hagag Group", role: "Promoteur et constructeur", body: "Promoteur et constructeur de l'hôtel du port de Tel Aviv. L'un des principaux promoteurs résidentiels et hôteliers d'Israël." },
      { name: "Jacob Hotels", role: "Exploitant", body: "Exploitant de l'hôtel du port dans le cadre d'un bail de longue durée, et de dix hôtels à travers Israël, du Golan à Eilat." },
      { name: "OGEN Hospitality", role: "Sponsor et gestionnaire", body: "Sponsor et gestionnaire de la société : structuration, acquisition, juridique et club des propriétaires." },
    ],
  },
  contact: {
    eyebrow: "Contact",
    title: "Venez voir la mer d'ici",
    body: "Venez au port pour une visite privée de l'unité témoin et de l'étage de la piscine, sur rendez-vous. Échanges en anglais, en français ou en hébreu.",
    emailL: "E-mail", phoneL: "Téléphone", officeL: "Bureau", office: "5 rue Mefi, Netanya, Israël",
    form: { firstName: "Prénom", lastName: "Nom", email: "E-mail", phone: "Téléphone", prefLang: "Langue préférée", message: "Message", submit: "Demander une visite", sending: "Envoi…" },
    successTitle: "Demande reçue",
    success: "Merci. Nous vous contacterons pour organiser votre visite.",
    error: "Une erreur est survenue. Veuillez réessayer ou nous écrire directement.",
    required: "Merci d'indiquer votre nom et un e-mail valide.",
  },
  footer: { tagline: "L'hôtellerie au bord de la Méditerranée, détenue sur le long terme.", rights: "Tous droits réservés", backTop: "Haut de page" },
  whatsapp: { label: "Écrivez-nous sur WhatsApp", message: "Bonjour, je souhaite organiser une visite de l'hôtel du port de Tel Aviv." },
};

const he = {
  nav: { property: "המלון", gallery: "גלריה", plans: "תוכניות", company: "החברה", club: "מועדון הבעלים", contact: "צור קשר", signIn: "כניסת חברים", cta: "בקשת סיור", menu: "תפריט", close: "סגירה" },
  hero: {
    eyebrow: "נכס מס׳ 1 · נמל תל אביב",
    lines: ["היכן שהנמל", "פוגש את הים"],
    intro: "בניין חדש של קבוצת חגג על קו המים של תל אביב, צעדים ספורים מטיילת הנמל ומהחוף. ארבעים וארבע יחידות מלון מרוהטות מאחורי חזית סבכה לבנה מגולפת שמסננת את אור הים התיכון, עם בריכה מקורה בגווני טורקיז, חדר כושר ולובי שקט של אבן בהירה.",
    explore: "גלו את המלון",
    scroll: "גללו",
    caption: "החזית",
  },
  marquee: ["נמל תל אביב", "בעלות רשומה בטאבו", "ארבעים וארבע יחידות מרוהטות", "מושכר למלונות ג׳ייקוב", "שלושים לילות בשנה", "פתיחה 2027"],
  stats: {
    eyebrow: "נכס מס׳ 1",
    title: "ארבעים וארבע יחידות, אופק אחד",
    items: [
      { v: "44", k: "יחידות מלון, נמסרות מרוהטות" },
      { v: "טאבו", k: "בעלות מלאה רשומה" },
      { v: "ים", k: "יחידות פונות לים עם מרפסות" },
      { v: "בריכה · כושר", k: "בריכה מקורה, חדר כושר, לאונג׳ לובי" },
      { v: "מפעיל", k: "מושכר ומופעל על ידי מלונות ג׳ייקוב" },
      { v: "2027", k: "פתיחה מתוכננת" },
    ],
  },
  gallery: {
    eyebrow: "הבניין",
    title: "קירות לבנים, מים בטורקיז, אור ים תיכוני",
    view: "הצג",
    captions: ["החזית", "יחידה מול הים", "בריכה מקורה", "חדר כושר", "לובי", "לאונג׳", "פנים היחידות", "תאורת הלובי"],
  },
  plans: {
    eyebrow: "תוכניות",
    title: "שתי קומות מול הים התיכון",
    body: "המלון ממוקם בקומות הראשונה והשנייה, מעל לובי משלו עם מעלית ייעודית, אבטחה וחדרי שירות. עשרים ושתיים יחידות בכל קומה, בשטח של 19 עד 32 מ״ר, כל אחת עם מרפסת פתוחה לבריזה מהים; הבריכה המקורה וחדר הכושר נמצאים בקומה השנייה.",
    tabs: [
      { label: "קומת לובי", meta: "קרקע", desc: "לובי מלון ומעלית מלון, נפרדים מלובי הדיירים; בית כנסת; שלוש יחידות מסחר לרחוב." },
      { label: "קומה ראשונה", meta: "יחידות 1–22", desc: "יחידות בחזית הים עם מרפסות של 11–28 מ״ר; יחידות פינה של 26–32 מ״ר." },
      { label: "קומה שנייה", meta: "יחידות 23–44", desc: "בריכה מקורה ומרפסתה, אזור טכני לחדר הכושר, חדר ביטחון; מרפסות של 11–13 מ״ר." },
    ],
    note: "התוכניות מתוך חוברת המכירה של היזם, ברזולוציית מסך; השטחים כמסומן בתוכניות. התוכניות הסופיות והשטחים הרשומים כפופים למסמכי הבעלות.",
    enlarge: "הגדלת התוכנית",
  },
  film: {
    eyebrow: "סרט",
    title: "הנמל, מן המים",
    body: "סרט קצר על פורט TLV: קירות לבנים, מים בטורקיז ואור הערב מעל הנמל, צעדים ספורים מהטיילת ומהחוף.",
    status: "פורט TLV · מלון ורזידנס",
    play: "הפעלה עם קול",
  },
  company: {
    eyebrow: "החברה",
    title: "הקירות מול הים בבעלותנו. את החדרים מנהלים הטובים ביותר.",
    body: "OGEN היא חברת אחזקות, לא מפעילת מלונות. היא מחזיקה בנדל״ן מלונאי במיקומים הטובים בישראל, לאורך הים התיכון ומעבר לו, ומשכירה כל מלון בשכירות ארוכת טווח למותג מבוסס שמפעיל אותו תחת שמו.",
    pillars: [
      { k: "בעלות", title: "כתובות מובחרות, בבעלות מלאה", body: "כל נכס רשום בטאבו על שם החברה. המשקיעים מחזיקים במניות החברה ולא בחדר בודד, כך שלכל בעלים יש חלק בכל מלון." },
      { k: "הפעלה", title: "מושכר למלונות ג׳ייקוב", body: "שכירות ארוכת טווח לרשת של עשרה מלונות: הכנסה קבועה לחברה, ניהול מקצועי, וללא מעורבות יומיומית של בעלי המניות. המלון נושא את שם המפעיל." },
      { k: "צמיחה", title: "ממלון אחד לאוסף", body: "ההון שנותר לאחר הרכישה הראשונה, יחד עם מימון בנקאי, מופנה למלון הבא. המטרה: רשת מלונות בוטיק ברחבי ישראל, מהחוף ועד המדבר." },
    ],
  },
  club: {
    eyebrow: "מועדון הבעלים",
    title: "הפינה שלך בים התיכון",
    body: "בעלי המניות הם חברי הבית. הבעלות מגיעה עם הזכות להתארח מול הים, ועם הטבות בכל עשרת מלונות ג׳ייקוב בישראל.",
    perks: [
      { title: "שלושים לילות בשנה, בנמל", body: "בשהייה אחת או בכמה, בכל עונה. חברים שאינם מנצלים את הלילות יכולים להעבירם לאחרים או לבחור בקצבה קבועה." },
      { title: "כרטיס חבר לכל הרשת", body: "כרטיס המועדון של מלונות ג׳ייקוב: מחירים מועדפים במלונות הרשת, מנווה אטיב שבגולן ועד אילת, כולל שנקין TLV, הרמוני ירושלים ומצפה רמון." },
      { title: "מקום בחברה צומחת", body: "בעלי המניות מחזיקים בכל נכס שהחברה רוכשת, לא רק בראשון." },
    ],
    signIn: "כניסת חברים",
    note: "בעלי מניות מוזמנים נכנסים עם כתובת הדוא״ל שאליה נשלחה ההזמנה. המסמכים, הנתונים וההצבעות נמצאים שם.",
    member: "חבר",
    ownerNo: "בעלים מס׳ 01 מתוך 44",
  },
  partners: {
    eyebrow: "שותפים",
    title: "הידיים מאחורי החזית הלבנה",
    list: [
      { name: "קבוצת חגג", role: "יזם ובונה", body: "היזם והבונה של נכס נמל תל אביב. מהיזמים המובילים בישראל למגורים ולמלונאות." },
      { name: "מלונות ג׳ייקוב", role: "מפעיל", body: "מפעיל מלון הנמל בשכירות ארוכת טווח, ועשרה מלונות ברחבי ישראל, מהגולן ועד אילת." },
      { name: "OGEN Hospitality", role: "יוזם ומנהל", body: "היוזם והמנהל של החברה: מבנה, רכישה, משפט ומועדון הבעלים." },
    ],
  },
  contact: {
    eyebrow: "צור קשר",
    title: "בואו לראות את הים מכאן",
    body: "בואו לנמל לסיור פרטי ביחידה לדוגמה ובקומת הבריכה, בתיאום מראש. השיחות באנגלית, בצרפתית או בעברית.",
    emailL: "דוא״ל", phoneL: "טלפון", officeL: "משרד", office: "Mefi St. 5, Netanya, Israel",
    form: { firstName: "שם פרטי", lastName: "שם משפחה", email: "דוא״ל", phone: "טלפון", prefLang: "שפה מועדפת", message: "הודעה", submit: "בקשת סיור", sending: "שולח…" },
    successTitle: "הבקשה התקבלה",
    success: "תודה. ניצור קשר לתיאום הביקור.",
    error: "משהו השתבש. נסו שוב או כתבו לנו ישירות.",
    required: "נא למלא שם וכתובת דוא״ל תקינה.",
  },
  footer: { tagline: "מלונאות על חוף הים התיכון, מוחזקת לטווח ארוך.", rights: "כל הזכויות שמורות", backTop: "חזרה למעלה" },
  whatsapp: { label: "שלחו לנו הודעה בוואטסאפ", message: "שלום, אשמח לתאם סיור במלון בנמל תל אביב." },
};

export const T = { en, fr, he };
export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "he", label: "עב", name: "עברית" },
];
